import { RestService, Rest } from '@abp/ng.core';
import type { PagedResultDto } from '@abp/ng.core';
import { Injectable } from '@angular/core';
import type { GetMeasurementTypeInputDto, MeasurementTypeCreateDto, MeasurementTypeDto, MeasurementTypeExcelDownloadDto, MeasurementTypeUpdateDto } from '../dtos/measurement-type/models';
import type { DownloadTokenResultDto, GetByIdsInputDto } from '../dtos/shared/models';

@Injectable({
  providedIn: 'root',
})
export class MeasurementTypeService {
  apiName = 'WoodSupply';
  

  create = (input: MeasurementTypeCreateDto, config?: Partial<Rest.Config>) =>
    this.restService.request<any, MeasurementTypeDto>({
      method: 'POST',
      url: '/api/woodsupply/measurementTypes',
      body: input,
    },
    { apiName: this.apiName,...config });
  

  delete = (id: number, config?: Partial<Rest.Config>) =>
    this.restService.request<any, void>({
      method: 'DELETE',
      url: `/api/woodsupply/measurementTypes/${id}`,
    },
    { apiName: this.apiName,...config });
  

  deleteByIds = (ids: number[], config?: Partial<Rest.Config>) =>
    this.restService.request<any, void>({
      method: 'DELETE',
      url: '/api/woodsupply/measurementTypes',
      params: { ids },
    },
    { apiName: this.apiName,...config });
  

  get = (id: number, config?: Partial<Rest.Config>) =>
    this.restService.request<any, MeasurementTypeDto>({
      method: 'GET',
      url: `/api/woodsupply/measurementTypes/${id}`,
    },
    { apiName: this.apiName,...config });
  

  getDownloadToken = (config?: Partial<Rest.Config>) =>
    this.restService.request<any, DownloadTokenResultDto>({
      method: 'GET',
      url: '/api/woodsupply/measurementTypes/download-token',
    },
    { apiName: this.apiName,...config });
  

  getList = (input: GetMeasurementTypeInputDto, config?: Partial<Rest.Config>) =>
    this.restService.request<any, PagedResultDto<MeasurementTypeDto>>({
      method: 'GET',
      url: '/api/woodsupply/measurementTypes',
      params: { name: input.name, code: input.code, sorting: input.sorting, skipCount: input.skipCount, maxResultCount: input.maxResultCount },
    },
    { apiName: this.apiName,...config });
  

  getListAsExcelFile = (input: MeasurementTypeExcelDownloadDto, config?: Partial<Rest.Config>) =>
    this.restService.request<any, Blob>({
      method: 'GET',
      responseType: 'blob',
      url: '/api/woodsupply/measurementTypes/as-excel-file',
      params: { downloadToken: input.downloadToken, fields: input.fields, name: input.name, code: input.code, sorting: input.sorting, skipCount: input.skipCount, maxResultCount: input.maxResultCount },
    },
    { apiName: this.apiName,...config });
  

  getListByIds = (input: GetByIdsInputDto, config?: Partial<Rest.Config>) =>
    this.restService.request<any, MeasurementTypeDto[]>({
      method: 'GET',
      url: '/api/woodsupply/measurementTypes/by-ids',
      params: { ids: input.ids },
    },
    { apiName: this.apiName,...config });
  

  update = (id: number, input: MeasurementTypeUpdateDto, config?: Partial<Rest.Config>) =>
    this.restService.request<any, MeasurementTypeDto>({
      method: 'PUT',
      url: `/api/woodsupply/measurementTypes/${id}`,
      body: input,
    },
    { apiName: this.apiName,...config });

  constructor(private restService: RestService) {}
}
